import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api } from "../api";
import { useAuth } from "../App";

export default function LoginEmpleado() {
  const [dni, setDni]     = useState("");
  const [pin, setPin]     = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate  = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const data = await api.loginEmpleado(dni.trim(), pin);
      login(data.token, { ...data.usuario, rol: "empleado" });
      navigate("/empleado");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="page-center" style={{ background: "var(--cream)" }}>
      <div style={{ width: "100%", maxWidth: 400 }}>
        <div style={{ textAlign: "center", marginBottom: 40 }}>
          <img src="/logo-azul.png" alt="FRICSA" style={{ height: 100, marginBottom: 4 }} />
          <div style={{ color: "var(--gray)", fontSize: 14 }}>
            Portal de recibos de sueldo
          </div>
        </div>

        <div className="card">
          <h2 style={{ marginBottom: 24, fontSize: 18, color: "var(--navy)" }}>
            Ingresá con tu DNI y PIN
          </h2>
          <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: 18 }}>
            <div className="input-group">
              <label>DNI</label>
              <input
                type="text"
                inputMode="numeric"
                value={dni}
                onChange={e => setDni(e.target.value)}
                placeholder="Sin puntos ni espacios"
                required
                autoFocus
              />
            </div>
            <div className="input-group">
              <label>PIN</label>
              <input
                type="password"
                inputMode="numeric"
                value={pin}
                onChange={e => setPin(e.target.value)}
                placeholder="Tu PIN de acceso"
                required
              />
            </div>
            {error && <div className="alert alert-error">{error}</div>}
            <button type="submit" className="btn btn-primary btn-full" disabled={loading}>
              {loading ? <><span className="spinner" style={{ width:18,height:18 }} /> Ingresando...</> : "Ingresar"}
            </button>
          </form>
        </div>

        <div style={{ textAlign: "center", marginTop: 20, fontSize: 13, color: "var(--gray)" }}>
          ¿Sos de RRHH?{" "}
          <Link to="/admin" style={{ color: "var(--navy)", fontWeight: 600 }}>
            Panel de administración
          </Link>
        </div>
      </div>
    </div>
  );
}
